import { Link } from "react-router-dom";
import retrato from "@/assets/eliveuton.webp";

/**
 * Hero institucional da home: quem sou e as frentes de trabalho. Não
 * destaca nenhum produto específico — cada frente tem a sua página.
 */
const HeroNew = () => (
  <section className="mx-auto max-w-[1180px] px-8 pb-16 pt-[82px] max-[900px]:px-5">
    <div className="grid grid-cols-[1.05fr_.95fr] items-center gap-14 max-[900px]:grid-cols-1">
      <div>
        <span className="inline-flex h-[30px] items-center gap-2 rounded-full bg-accent px-3.5 text-xs font-bold text-primary">
          <span className="h-1.5 w-1.5 rounded-full bg-current" />
          Tecnologia para pequenas e médias empresas
        </span>
        <h1 className="mt-[22px] text-[54px] font-bold leading-[1.05] tracking-[-0.04em] max-[900px]:text-[38px]">
          Site, sistema e automação para sua empresa vender mais e trabalhar menos.
        </h1>
        <p className="mt-5 max-w-[540px] text-[17.5px] leading-[1.65] text-muted-foreground">
          Sou Eliveuton Souza, desenvolvedor fullstack. Construo a presença digital que traz
          cliente, o sistema que tira sua operação da planilha e a automação com IA que responde no
          lugar da equipe.
        </p>
        <div className="mt-[30px] flex flex-wrap gap-[11px]">
          <Link
            to="/contato"
            className="inline-flex h-[50px] items-center rounded-full bg-primary px-[26px] text-[14.5px] font-bold text-primary-foreground transition hover:brightness-[.94]"
          >
            Agendar diagnóstico gratuito
          </Link>
          <a
            href="#frentes"
            className="inline-flex h-[50px] items-center rounded-full border border-border bg-card px-6 text-[14.5px] font-bold text-foreground transition hover:brightness-[.94]"
          >
            Ver o que eu faço
          </a>
        </div>
        <p className="mt-4 text-[12.5px] text-muted-foreground">
          30 minutos, sem compromisso · resposta em até 1 dia útil
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3.5">
        <div className="row-span-2 overflow-hidden rounded-[18px] border border-border bg-muted">
          <img
            src={retrato}
            alt="Eliveuton Souza"
            width={800}
            height={1000}
            loading="eager"
            className="h-full max-h-[440px] w-full object-cover"
          />
        </div>
        <Link
          to="/servicos#presenca-digital"
          className="rounded-[18px] border border-border bg-card p-[18px] transition-colors hover:border-primary"
        >
          <div className="text-[11px] font-bold uppercase tracking-[0.07em] text-muted-foreground">
            Sites e sistemas
          </div>
          <div className="mt-2 text-[15px] font-bold leading-[1.35]">
            Do site institucional ao sistema sob medida
          </div>
        </Link>
        <Link
          to="/automacao-empresarial"
          className="rounded-[18px] bg-deep p-[18px] text-deep-foreground transition hover:brightness-110"
        >
          <div className="text-[11px] font-bold uppercase tracking-[0.07em] text-primary-glow">
            Automação com IA
          </div>
          <div className="mt-2 text-[15px] font-bold leading-[1.35]">
            CRM e atendimento que respondem sozinhos
          </div>
        </Link>
      </div>
    </div>
  </section>
);

export default HeroNew;
